import * as z from "zod/v4";

export const adminToggleMobileMessageAi = {
  name: "adminToggleMobileMessageAi" as const,
  input: z.object({
    teamId: z.string(),
    conversationId: z.string(),
    aiDisabled: z.boolean(),
  }),
  output: z.object({ success: z.boolean() }),
};
